import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const LogoutIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="3px" y="0px"
                 viewBox="0 0 1800 1500">
                <g>
                    <path className='path' stroke="#3D4A78" strokeWidth="50px" fill="fill:#3D4A78" d="M1185.609,435.609l-66.285,66.281l201.23,201.234H656.25v93.75h664.305l-201.23,201.234
		l66.285,66.281L1500,750L1185.609,435.609z M1185.609,435.609"/>
                    <path className='path' stroke="#3D4A78" strokeWidth="50px" fill="fill:#3D4A78" d="M1031.25,1406.25H93.75V93.75h937.5v93.75H1125V46.875C1125,20.965,1104.035,0,1078.125,0H46.875
		C20.965,0,0,20.965,0,46.875v1406.25C0,1479.035,20.965,1500,46.875,1500h1031.25c25.91,0,46.875-20.965,46.875-46.875V1312.5
		h-93.75V1406.25z M1031.25,1406.25"/>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default LogoutIcon;